import { z } from 'zod'

/**
 * Base snapshot envelope schema — wraps all module data.
 * As per spec §4.1.
 */
export function DataSnapshotSchema<TData>(dataSchema: z.ZodType<TData>) {
  return z.object({
    updatedAt: z.string(),
    source: z.string(),
    version: z.number(),
    data: dataSchema,
  })
}

export type DataSnapshot<TData> = {
  updatedAt: string
  source: string
  version: number
  data: TData
}
